var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"630px"},attrs:{"id":_vm.id,"option":_vm.option}})])}
var staticRenderFns = []

export { render, staticRenderFns }